import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'メルマガ',

  // 選択サービス名
  serviceName: null,
  
  // model
  magazineModel: [],
  deliveryTypeMstModel: [],
  relationalNoticeTypeModel: [],
  // noticeTypeMstModel: [],

  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {magazineParams, deliveryTypeMstParams, noticeTypeMstParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'serviceMailMagazine',
          'deliveryTypeMst',
          'deliveryTypeMst',
          // 'noticeTypeMst'
        ],
        [
          'v1ServiceMailMagazineListGet',
          'v1DeliveryTypeMstListGet',
          'v1DeliveryTypeMstRelationalNoticeTypeMstListGet',
          // 'v1NoticeTypeMstListGet'
        ],
        [
          magazineParams,
          deliveryTypeMstParams,
          deliveryTypeMstParams,
          // noticeTypeMstParams
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceName', res[0].data.serviceName)
            commit('setMagazineModel', res[0].data.serviceMailMagazineSettings)
            commit('setDeliveryTypeMstModel', res[1].data.deliveryTypeMsts)
            commit('setRelationalNoticeTypeModel', res[2].data.deliveryType_noticeType_rel)
            // commit('setNoticeTypeMstModel', res[3].data.noticeTypeMsts)
            console.log('magazineModel', state.magazineModel)
            console.log('deliveryTypeMstModel', state.deliveryTypeMstModel)
            console.log('relationalNoticeTypeModel', state.relationalNoticeTypeModel)
            // console.log('noticeTypeMstModel', state.noticeTypeMstModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.DeliveryTypeMstId)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // service name
  setServiceName (state, str) {
    state.serviceName = str
  },

  // model
  setMagazineModel (state, data) {
    Vue.set(state, 'magazineModel', data)
  },
  setDeliveryTypeMstModel (state, data) {
    Vue.set(state, 'deliveryTypeMstModel', data)
  },
  setRelationalNoticeTypeModel (state, data) {
    Vue.set(state, 'relationalNoticeTypeModel', data)
  },
  // setNoticeTypeMstModel (state, data) {
  //   Vue.set(state, 'noticeTypeMstModel', data)
  // },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpMailMagazineName', null)
    Vue.set(state.values, 'inpMailAddress', null)
    Vue.set(state.values, 'inpDeliveryTypeMstId', '')
    Vue.set(state.values, 'inpNoticeTypeMstId', '')
    Vue.set(state.values, 'inpKeyword', [])
    Vue.set(state.values, 'inpKeywordSearchType', null)
    Vue.set(state.values, 'inpIgnoreKeyword', [])
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpMailMagazineName', data.mailMagazineName)
    Vue.set(state.values, 'inpMailAddress', data.mailMagazineAddress)
    Vue.set(state.values, 'inpDeliveryTypeMstId', data.deliveryTypeMstUuid)
    Vue.set(state.values, 'inpNoticeTypeMstId', data.noticeTypeMstUuid)
    Vue.set(state.values, 'inpKeyword', data.keywords.join(' '))
    Vue.set(state.values, 'inpKeywordSearchType', data.keywordsQueryKbn)
    Vue.set(state.values, 'inpIgnoreKeyword', data.exclusiveKeywords.join(' '))
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
